import {
  Box as MuiBox,
  BoxProps as MuiBoxProps,
  RadioGroup as MuiRadioGroup,
  RadioGroupProps as MuiRadioGroupProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledRadioGroup = styled(MuiRadioGroup)<MuiRadioGroupProps>(
  ({ theme: { spacing } }) => ({
    margin: spacing(0, 0, 0, 2),
    gap: spacing(2),

    '& .MuiFormControlLabel-root': {
      margin: spacing(0, 3.6, 0, 0),

      '&:last-of-type': {
        margin: '0',
      },
    },

    '& .MuiFormControlLabel-label': {
      marginLeft: spacing(0.8),
    },
  })
);

export const FlexCenterBox = styled(MuiBox)<MuiBoxProps>({
  display: 'flex',
  alignItems: 'center',
});

export const FilterContainer = styled(MuiBox)<MuiBoxProps>(
  ({ theme: { spacing, palette, shape } }) => ({
    display: 'flex',
    padding: spacing(2.4, 1.6),
    backgroundColor: palette.background.default,
    borderRadius: shape.borderRadius,
  })
);
